var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 168
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__a",
    x1: "6.229%",
    x2: "99.659%",
    y1: "49.914%",
    y2: "49.914%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4287C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__b",
    x1: "-72.018%",
    x2: "143.997%",
    y1: "21.57%",
    y2: "69.82%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4287C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__c",
    x1: "5.978%",
    x2: "99.467%",
    y1: "49.913%",
    y2: "49.913%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4287C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__d",
    x1: "5.888%",
    x2: "99.583%",
    y1: "49.963%",
    y2: "49.963%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4287C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__e",
    x1: "6.25%",
    x2: "100.399%",
    y1: "49.966%",
    y2: "49.966%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4287C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield_svg__f",
    x1: "6.354%",
    x2: "100.155%",
    y1: "49.815%",
    y2: "49.815%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4287C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield_svg__a)",
    fillRule: "nonzero",
    d: "M0 77.3c8.7.3 16.2 8.4 15.9 14.7 0-13.2 13.4-14.7 13.4-14.7s-13.8-5-12.5-15.6c-.9 6.5-6.6 15.8-16.8 15.6",
    opacity: 0.547
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4287C6",
    fillRule: "nonzero",
    d: "M126.9 65.616V31.9c-.3 0-.6 0-.8.1L83.8 47.8c-.8.4-1.4 1.2-1.4 2.1v51.8c0 8.7 4.5 16.9 14.4 25.7 7 6.2 16 12.2 24.7 17.9 1.4.9 2.8 1.9 4.2 2.8.4.3.8.4 1.2.4v-33.116q-.448.016-.9.016c-13.697 0-24.8-11.148-24.8-24.9s11.103-24.9 24.8-24.9q.452 0 .9.016"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#428BCA",
    strokeWidth: 2.976,
    d: "m175 42-48.1-18q-.9-.3-1.8 0L77 42c-1 .4-1.6 1.3-1.6 2.3V103c0 9.9 5.2 19.2 16.4 29.2 7.9 7.1 18.1 13.8 28 20.3 1.6 1 3.2 2.1 4.8 3.1.4.3.9.4 1.4.4s1-.1 1.4-.4c1.6-1 3.2-2.1 4.7-3.1 9.9-6.5 20.1-13.2 28.1-20.3 11.2-10 16.4-19.3 16.4-29.2V44.4c0-1.1-.7-2-1.6-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBF12",
    fillRule: "nonzero",
    d: "m139.4 85-15.5 15.9c-.3.3-.7.5-1.1.5s-.8-.2-1.1-.5l-9-9.3c-.3-.3-.5-.7-.5-1.2 0-.4.2-.8.5-1.2l2.6-2.6c.3-.3.7-.5 1.1-.5s.8.2 1.1.5l5.3 5.5L134.6 80c.3-.3.7-.5 1.1-.5s.8.2 1.1.5l2.6 2.6c.3.3.5.7.5 1.2s-.2.9-.5 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield_svg__b)",
    fillRule: "nonzero",
    d: "M231.2 90.2c5.3.2 9.9 5.2 9.7 9.2 0-8.2 8.2-9.2 8.2-9.2s-8.4-3.1-7.6-9.7c-.6 4.1-4.1 9.9-10.3 9.7",
    opacity: 0.547
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield_svg__c)",
    fillRule: "nonzero",
    d: "M193.5 20.2c5.9.2 11 5.8 10.8 10.1 0-9.1 9.1-10.1 9.1-10.1s-9.4-3.5-8.5-10.7c-.7 4.5-4.5 10.9-11.4 10.7",
    opacity: 0.547
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield_svg__d)",
    fillRule: "nonzero",
    d: "M193.5 160.8c4.1.1 7.7 4.1 7.5 7.2 0-6.5 6.4-7.2 6.4-7.2s-6.5-2.5-5.9-7.7c-.5 3.2-3.2 7.8-8 7.7",
    opacity: 0.547
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield_svg__e)",
    fillRule: "nonzero",
    d: "M48.6 10.2c5.6.2 10.5 5.5 10.2 9.7 0-8.6 8.6-9.7 8.6-9.7s-8.9-3.3-8-10.2c-.6 4.3-4.2 10.4-10.8 10.2",
    opacity: 0.547
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield_svg__f)",
    fillRule: "nonzero",
    d: "M46.6 151c7.1.2 13.2 6.9 12.9 12.1 0-10.8 10.9-12.1 10.9-12.1s-11.2-4.1-10.2-12.8c-.7 5.3-5.2 13-13.6 12.8",
    opacity: 0.547
  }))));
};
export default SvgShield;